import { ChevronLeft, ChevronRight } from "lucide-react";

const Pagination = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
    const pageNumbers = [];
    const lastPage = Math.ceil(totalItems / itemsPerPage);

    if (lastPage < 8) {
        for (let i = 2; i <= Math.ceil(totalItems / itemsPerPage) - 1; i++) {
            pageNumbers.push(i);
        }
    } else if (currentPage < 4) {
        for (let i = 2; i < 5; i++) {
            pageNumbers.push(i);
        }
    } else if (currentPage > lastPage - 3) {
        for (let i = lastPage - 3; i < lastPage; i++) {
            pageNumbers.push(i);
        }
    } else {
        pageNumbers.push(currentPage - 1);
        pageNumbers.push(currentPage);
        pageNumbers.push(currentPage + 1);
    }

    const baseButtonClass = "flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 text-xs sm:text-sm font-medium rounded-lg transition-colors";
    const activeClass = "bg-primary text-white";
    const inactiveClass = "text-gray-600 hover:bg-gray-100";
    const disabledClass = "text-gray-300 cursor-not-allowed";

    return (
        <nav className="overflow-x-auto">
            <ul className="flex items-center justify-center gap-0.5 sm:gap-1">
                {/* previous button */}
                <li>
                    <button
                        className={`${baseButtonClass} ${currentPage === 1 ? disabledClass : inactiveClass}`}
                        aria-label="Previous"
                        onClick={() => paginate(0)}
                        disabled={currentPage === 1}
                    >
                        <ChevronLeft className="w-4 h-4" />
                    </button>
                </li>

                {/* first page */}
                <li>
                    <button
                        onClick={() => paginate(1)}
                        className={`${baseButtonClass} ${currentPage === 1 ? activeClass : inactiveClass}`}
                    >
                        1
                    </button>
                </li>

                {/* ellipsis before */}
                {currentPage > 3 && lastPage > 7 && (
                    <li>
                        <span className="flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 text-gray-400">
                            ...
                        </span>
                    </li>
                )}

                {/* page numbers */}
                {pageNumbers.map((number) => (
                    <li key={number}>
                        <button
                            onClick={() => paginate(number)}
                            className={`${baseButtonClass} ${currentPage === number ? activeClass : inactiveClass}`}
                        >
                            {number}
                        </button>
                    </li>
                ))}

                {/* ellipsis after */}
                {currentPage < lastPage - 2 && lastPage > 7 && (
                    <li>
                        <span className="flex items-center justify-center w-8 h-8 sm:w-9 sm:h-9 text-gray-400">
                            ...
                        </span>
                    </li>
                )}

                {/* last page */}
                {lastPage > 1 && (
                    <li>
                        <button
                            onClick={() => paginate(lastPage)}
                            className={`${baseButtonClass} ${currentPage === lastPage ? activeClass : inactiveClass}`}
                        >
                            {lastPage}
                        </button>
                    </li>
                )}

                {/* next button */}
                <li>
                    <button
                        className={`${baseButtonClass} ${currentPage === lastPage ? disabledClass : inactiveClass}`}
                        aria-label="Next"
                        onClick={() => paginate(totalItems + 10)}
                        disabled={currentPage === lastPage}
                    >
                        <ChevronRight className="w-4 h-4" />
                    </button>
                </li>
            </ul>
        </nav>
    );
};

export default Pagination;
